import SectionTitle from "../../../common/sectionTitle";
import tredingThumb from "../../../assets/images/treding/about-us-03.jpg";
import account from "../../../assets/images/treding/account.svg";
import deposit from "../../../assets/images/treding/deposit.svg";
import cart from "../../../assets/images/treding/cart.svg";
import TredingStyleWrapper from "./Treding.style";

const Treding = () => {

  return (
    <TredingStyleWrapper id="treding" >
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div>
              <SectionTitle title="we make crypto easy,sign up and get started" subtitle="3 STEPS TO START TREDING" />
              <div className="treding_content">

                <div className="treding_content_item">
                  <div className="content_item_icon">
                    <img src={account} alt="icon" />
                  </div>
                  <div className="content_item_text">
                    <h4>create your account</h4>
                    <p>lorem ipsum dolor sit amet,consectetur adipiscing elit,sed do eiusmod tempor incididunt ut labore et dolore</p>
                  </div>
                </div>

                <div className="treding_content_item">
                  <div className="content_item_icon">
                    <img src={deposit} alt="icon" />
                  </div>
                  <div className="content_item_text">
                    <h4>make a deposit </h4>
                    <p>lorem ipsum dolor sit amet,consectetur adipiscing elit,sed do eiusmod tempor incididunt ut labore et dolore</p>
                  </div>
                </div>

                <div className="treding_content_item">
                  <div className="content_item_icon">
                    <img src={cart} alt="icon" />
                  </div>
                  <div className="content_item_text">
                    <h4>save , buy & sell</h4>
                    <p>lorem ipsum dolor sit amet,consectetur adipiscing elit,sed do eiusmod tempor incididunt ut labore et dolore</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 trendingImage_section">
            <img src={tredingThumb} alt="img" />
          </div>
        </div>
      </div>
    </TredingStyleWrapper>
  );
};

export default Treding;
